const MS_PER_DAY = 86_400_000;

/** UTC0 当月 1 日 00:00:00.000 */
export function utcMonthStartMs(refMs = Date.now()): number {
  const d = new Date(refMs);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1, 0, 0, 0, 0);
}

/** UTC0 当月最后一日 23:59:59.999 */
export function utcMonthEndMs(refMs = Date.now()): number {
  const d = new Date(refMs);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0, 23, 59, 59, 999);
}

/** UTC0 自然日 00:00:00.000 */
function utcDayStartMs(tsMs: number): number {
  const d = new Date(tsMs);
  return Date.UTC(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    0,
    0,
    0,
    0
  );
}

/** [startMs, endMs] 内 UTC0 自然日天数（含首尾日；入参通常为 UTC 日 0 点） */
function utcInclusiveCalendarDays(startMs: number, endMs: number): number {
  if (endMs < startMs) return 0;
  return Math.floor((endMs - startMs) / MS_PER_DAY) + 1;
}

/**
 * 从 startMs 到 endMs 的 UTC0 自然日天数（含首尾日）。
 * 用于「已计息天数」等与平台日息一致的展示。
 */
export function calcUtcInclusiveCalendarDays(
  startMs?: number,
  endMs = Date.now()
): number {
  if (!startMs || startMs <= 0) return 0;
  const end = endMs > 0 ? endMs : Date.now();
  if (end < startMs) return 0;
  return utcInclusiveCalendarDays(utcDayStartMs(startMs), utcDayStartMs(end));
}

/**
 * 托管主单「本月参与进度」
 * - 窗口起点：max(本月 UTC0 月初, tradeStartsAt)
 * - 窗口终点（分母）：本月 UTC0 月末
 * - 已参与终点（分子）：min(now, 本月月末)
 */
export function calcCustodyMonthProgress(
  tradeStartsAtMs: number,
  nowMs = Date.now(),
  refMs = nowMs
): { pct: number; joinedDays: number; eligibleDays: number } {
  if (!tradeStartsAtMs || tradeStartsAtMs <= 0) {
    return { pct: 0, joinedDays: 0, eligibleDays: 0 };
  }

  const monthStart = utcMonthStartMs(refMs);
  const monthEnd = utcMonthEndMs(refMs);
  const windowStart = Math.max(monthStart, tradeStartsAtMs);

  if (windowStart > monthEnd) {
    return { pct: 0, joinedDays: 0, eligibleDays: 0 };
  }

  const startDay = utcDayStartMs(windowStart);
  const endDay = utcDayStartMs(monthEnd);
  const joinedEndDay = utcDayStartMs(Math.min(nowMs, monthEnd));

  const eligibleDays = calcUtcInclusiveCalendarDays(startDay, endDay);
  const joinedDays = calcUtcInclusiveCalendarDays(startDay, joinedEndDay);
  const pct =
    eligibleDays > 0 ? Math.min(100, (joinedDays / eligibleDays) * 100) : 0;

  return { pct, joinedDays, eligibleDays };
}
